/** @jsx jsx */
import {
  Badge,
  Box,
  Button,
  Flex,
  Link,
  ShoppingCartIcon,
  Text,
} from '@bottlebooks/gatsby-theme-base';
import { Trans } from '@lingui/macro';
import { jsx } from 'theme-ui';
import useSnipcart from '../../useSnipcart';

/**
 * @returns
 */
export default function CartMenu({ ...rest }) {
  return (
    <Flex align="center" sx={{ paddingY: 3 }} {...rest}>
      <ShoppingCartText />
      <ShoppingCartIndicator />
    </Flex>
  );
}

/**
 *
 * @param {object} props
 * @param {'small' | 'normal' | 'mobile'} [props.variant]
 * @param {React.ReactElement} [props.children]
 * @returns
 */
export function ShoppingCartIndicator({ children }) {
  const { openCart, itemsInCartCount } = useSnipcart();
  return (
    <Box>
      <Button
        sx={{ border: 0, position: 'relative' }}
        onClick={() => openCart()}
      >
        <ShoppingCartIcon
          sx={{
            marginRight: 2,
            color: 'currentColor',
            height: 30,
            width: 30,
          }}
        />
        {itemsInCartCount > 0 && (
          <Badge
            sx={{
              position: 'absolute',
              paddingY: 0.5,
              backgroundColor: 'primary',
              color: 'onPrimary',
              right: 0,
              top: 0,
              transform: 'translate(-25%, -25%)',
            }}
          >
            {itemsInCartCount}
          </Badge>
        )}
      </Button>

      {children}
    </Box>
  );
}

/**
 * Shows text helping the user understand what they should do.
 * This can be used to inform the user of the maximum number
 * of wines they can request.
 */
export function ShoppingCartText() {
  const { openCart, itemsRemainingCount, maxItems } = useSnipcart();
  // If maxItems is Infinity, then don't show any explanation
  if (maxItems === Infinity) return null;
  return (
    <Text variant="small" sx={{ marginLeft: 3 }}>
      {itemsRemainingCount > 0 ? (
        itemsRemainingCount === 1 ? (
          <Trans>You can add one more product to your cart.</Trans>
        ) : (
          <Trans>
            You can add ${itemsRemainingCount} more products to your cart.
          </Trans>
        )
      ) : (
        <Text variant="small" sx={{ marginX: 3 }}>
          <Trans>You can request up to {maxItems} products.</Trans>{' '}
          <Link
            onClick={() => openCart()}
            sx={{
              padding: 0,
              margin: 0,
              font: 'inherit',
              fontSize: 'inherit',
              border: 'none',
              backgroundColor: 'transparent',
              color: 'primary',
            }}
          >
            <Trans>Remove wines to add others.</Trans>
          </Link>
        </Text>
      )}
    </Text>
  );
}
